<template>
  <div>
    <div v-if="deferredPrompt"  @click="install">
      <div class="icon">
        
      </div>
      <div>

      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        deferredPrompt: null
      };
    },
    created() {
      window.addEventListener("beforeinstallprompt", e => {
        e.preventDefault();
        // Stash the event so it can be triggered later.
        this.deferredPrompt = e;
      });
      window.addEventListener("appinstalled", () => {
        this.deferredPrompt = null;
      });
    },
    methods: {
      dismiss() {
        this.deferredPrompt = null;
      },
      install() {
        this.deferredPrompt.prompt();
      }
    }
  };
  </script>

